import {PrimerSlide, primerStyles} from './PrimerShell';
import {SlideCIllustration} from './PrimerIllustrations';

const CalendarIcon = () => (
  <svg width={20} height={20} viewBox="0 0 24 24" fill="none" aria-hidden="true">
    <path
      d="M5 4 H 19 A 2 2 0 0 1 21 6 V 20 A 2 2 0 0 1 19 22 H 5 A 2 2 0 0 1 3 20 V 6 A 2 2 0 0 1 5 4 Z"
      stroke="currentColor"
      strokeWidth={1.6}
    />
    <path d="M8 2 V 6 M16 2 V 6 M3 10 H 21" stroke="currentColor" strokeWidth={1.6} strokeLinecap="round" />
  </svg>
);

/** Primer slide C — "Many notice mornings change first."
 *  2×2 grid of daily-utility tiles + science callout. */
export const Glp1PrimerSlideC = () => (
  <PrimerSlide
    letter="C"
    headline="Many notice mornings change first."
    subhead="The app guides you from Day 1."
    ctaLabel="Next"
  >
    <div className={primerStyles.dailyWrap}>
      <SlideCIllustration />
      <div className={primerStyles.dailyScienceRow}>
        <span className={primerStyles.dailyScienceIcon}>
          <CalendarIcon />
        </span>
        <p className={primerStyles.dailyScienceText}>
          The guidance starts now, the app shows up everywhere your day is: your sleep debt, your energy schedule, your
          ideal bedtime. The medication kicks in by Day 7.
        </p>
      </div>
    </div>
  </PrimerSlide>
);

export default Glp1PrimerSlideC;
